const loaderObj = {
    color: "#aa00ff",
    loader: "dots",
    width: 70,
    height: 70,
    backgroundColor: "#616161",
    opacity: 0.5,
};

export default loaderObj;
